module.exports = __webpack_public_path__ + "images/edm_laptop_portal.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/email/edm_laptop_portal.png
// module id = 871
// module chunks = 3